import React, { useEffect, useState, memo } from 'react';
import { useT } from 'i18n/hooks/useT';

import { getFormattedTimestamp } from 'modules/Time';

import { HeroPhone } from '../../components/HeroPhone';
import {
  FeaturesHeroContainer,
  HeroBackgroundContainer,
  HeroPhoneContainer,
  HeroPhoneRecording,
  HeroTitle,
  RecordingIndicatorSVG,
} from './styles';

function FeaturesHeroSectionView() {
  const [seconds, setSeconds] = useState<number>(173);
  const text = getFormattedTimestamp(seconds * 1000, {
    roundMilliseconds: true,
    omitZeroHours: true,
  });
  const t = useT();

  useEffect(() => {
    const intervalId = setInterval(
      () => setSeconds(stateSeconds => stateSeconds + 1),
      1000
    );
    return () => clearInterval(intervalId);
    // We only want this to happen once, on mount, so we bypass this check
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FeaturesHeroContainer>
      <HeroTitle>
        {t(
          'FeaturesScreen.FeaturesHeroSection.Title',
          'Tools to power any podcast',
          'Anchor features page title'
        )}
      </HeroTitle>
      <HeroBackgroundContainer>
        <HeroPhoneContainer>
          <HeroPhoneRecording>
            <RecordingIndicatorSVG />
            <span>
              {t(
                'FeaturesScreen.HeroPhone.RecordingLabel',
                'Recording',
                'Recording label for an image of a phone recording audio'
              )}
            </span>
          </HeroPhoneRecording>
          <HeroPhone text={text} width="100%" />
        </HeroPhoneContainer>
      </HeroBackgroundContainer>
    </FeaturesHeroContainer>
  );
}

export const FeaturesHeroSection = memo(FeaturesHeroSectionView);
